import XmlFormatter from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/XmlFormatter";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

export const getAlertAttributes = (attrs: Record<string, unknown>) => ({
	type: typeof attrs.type === "string" ? attrs.type : "",
	title: typeof attrs.title === "string" ? attrs.title : "",
});

const alertFormatter: NodeSerializerSpec = async (state, node) => {
	state.write(`${XmlFormatter.openTag("alert", getAlertAttributes(node.attrs))}\n\n`);
	await state.renderContent(node);
	state.write(XmlFormatter.closeTag("alert"));
	state.closeBlock(node);
};

export default alertFormatter;
